import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormControl, Table, Dropdown, Badge, OverlayTrigger, Tooltip, Modal, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { graphql } from 'react-apollo';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import moment from 'moment';

// style
import s from './UsersList.css';

// helpers
import messages from '../../../../locale/messages';
import getLocationsQuery from '../../../../routes/site-admin/serviceFee/getLocations.graphql';
import debounce from '../../../../helpers/debounce';
import { capitalizeFirstLetter } from '../../../../helpers/capitalizeFirst';

// components
import CustomPagination from '../../../CustomPagination/CustomPagination';
import Link from '../../../Link/Link';

// Images
// import EditIcon from '../../../../../public/Icons/edit.png';
// import TrashIcon from '../../../../../public/Icons/bin.svg';
import ExportImage from '../../../../../public/Icons/export.png';

// Redux actions
import deleteUser from '../../../../actions/siteadmin/deleteUser';
import updateShopStatus from '../../../../actions/siteadmin/ManageShop/updateShopStatus';
import { toastr } from 'react-redux-toastr';
import { getAvatarUrl, getUiAvatarUrl } from '../../../../utils/getAvatarUrl';
import { FaEdit, FaTrash, FaChartBar, FaFilter } from 'react-icons/fa';
import { FaBan, FaPause, FaTruckFast } from 'react-icons/fa6';
import { USER_TYPE } from '../../../../constants';


class UsersList extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      currentPage: 1,
      keyword: '',
      showFilterModal: false,
      selectedStatus: '',
      draftStatus: '',
      location: '',
      draftLocation: '',
    };

    this.paginationData = this.paginationData.bind(this);
    this.handleKeywordSearch = debounce(this.handleKeywordSearch.bind(this));
    this.handleStatus = this.handleStatus.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.openFilterModal = this.openFilterModal.bind(this);
    this.closeFilterModal = this.closeFilterModal.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.clearDraftFilters = this.clearDraftFilters.bind(this);
  }

  handleKeywordSearch(keyword) {
    const { usersDetails: { refetch }, requestType } = this.props;
    const { selectedStatus, location } = this.state;

    const variables = {
      currentPage: 1,
      keyword,
      requestType,
      userStatus: selectedStatus || null,
      locationId: location ? parseInt(location, 10) : null,
    };

    this.setState({ keyword, currentPage: 1 });
    refetch(variables);
  }

  openFilterModal() {
    const { selectedStatus, location } = this.state;
    this.setState({ showFilterModal: true, draftStatus: selectedStatus, draftLocation: location });
  }

  closeFilterModal() {
    this.setState({ showFilterModal: false });
  }

  applyFilters() {
    const { usersDetails: { refetch }, requestType } = this.props;
    const { draftStatus, draftLocation, keyword } = this.state;
    this.setState({ selectedStatus: draftStatus, location: draftLocation, currentPage: 1, showFilterModal: false });
    refetch({
      currentPage: 1,
      keyword,
      requestType,
      userStatus: draftStatus || null,
      locationId: draftLocation ? parseInt(draftLocation, 10) : null,
    });
  }

  clearDraftFilters() {
    this.setState({ draftStatus: '', draftLocation: '' });
  }

  getActiveFilterCount() {
    const { selectedStatus, location } = this.state;
    let count = 0;
    if (selectedStatus) count++;
    if (location) count++;
    return count;
  }

  async handleDelete(id) {
    const { deleteUser, usersDetails: { refetch }, requestType } = this.props;
    const { keyword } = this.state;

    toastr.confirm('Are you sure you want to delete this user?', {
      onOk: async () => {
        const userType = (requestType === 'drivers') ? USER_TYPE.DRIVER : USER_TYPE.CUSTOMER;
        const variables = { currentPage: 1, keyword, requestType };
        const deleteUserResponse = await deleteUser(id, userType);
        this.setState({ currentPage: 1 });
        if (deleteUserResponse && deleteUserResponse.status === 200) {
          refetch(variables);
        }
      },
    });
  };

  paginationData(currentPage) {
    const { usersDetails: { refetch }, requestType } = this.props;
    const { keyword, selectedStatus, location } = this.state;

    const variables = {
      currentPage, keyword, requestType,
      userStatus: selectedStatus || null,
      locationId: location ? parseInt(location, 10) : null,
    };
    this.setState({ currentPage });
    refetch(variables);
  };

  async handleStatus(updateField, id, status, currentPage) {
    const { updateShopStatus, usersDetails: { refetch }, requestType } = this.props;
    const { keyword, selectedStatus, location } = this.state;
    const variables = {
      currentPage, keyword, requestType,
      userStatus: selectedStatus || null,
      locationId: location ? parseInt(location, 10) : null,
    };
    await updateShopStatus(updateField, id, status, currentPage, requestType === 'drivers' ? 2 : 1);
    refetch(variables);
  };

  renderBadgeStatus(user) {
    if (user.isBan) {
      return <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`tooltip-status-${user.id}`}>
            Driver is banned
          </Tooltip>
        }
      ><Badge pill variant='danger'><FaBan className='mr-1' />Banned</Badge></OverlayTrigger>
    }

    if (user.deletedAt) {
      return <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`tooltip-status-${user.id}`}>
            Driver was deleted
          </Tooltip>
        }
      ><Badge pill variant='danger'>Deleted</Badge></OverlayTrigger>
    }

    if (user.userStatus === 'pending') {
      return <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`tooltip-status-${user.id}`}>
            Driver registration is pending
          </Tooltip>
        }
      ><Badge pill variant='warning'><FaPause className='mr-1' />Pending</Badge></OverlayTrigger>
    }

    let badgeVariant = user.activeStatus === 'active' && user.isActive ? 'success' : 'light';
    let badgeText = user.activeStatus === 'active' && user.isActive ? 'Available' : 'Unavailable';
    let badgeTooltip = user.activeStatus === 'active' && user.isActive ? 'Driver available to receive an order' : 'Driver unavailable to receive an order';

    badgeVariant = user.isInProgressDelivery ? 'primary' : badgeVariant;
    badgeText = user.isInProgressDelivery ? 'In Progress' : badgeText;
    badgeTooltip = user.isInProgressDelivery ? 'Driver is in progress' : badgeTooltip;

    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`tooltip-status-${user.id}`}>
            {badgeTooltip}
          </Tooltip>
        }
      >
        <Badge pill variant={badgeVariant}>
          <FaTruckFast className='mr-1' />
          {badgeText}
        </Badge>
      </OverlayTrigger>
    )
  }

  // priorityFactor is the multiplier dispatch applies to this driver's distance:
  // 1 means untouched, 2 means they must be twice as close to win a job.
  renderAcceptance(user) {
    const acceptance = user.deliveryAcceptance;

    if (!acceptance || !acceptance.offers) {
      return <small className='text-muted'>No offers</small>;
    }

    const rate = Math.round(acceptance.acceptanceRate * 100);
    const factor = acceptance.priorityFactor || 1;
    const isPenalised = factor > 1;

    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`tooltip-acceptance-${user.id}`}>
            {`${acceptance.accepted} of ${acceptance.offers} offers accepted in the last ${acceptance.windowDays} days. `}
            {acceptance.noResponse > 0 && `${acceptance.noResponse} unanswered, counted as half a refusal. `}
            {isPenalised
              ? `Ranked as if ${factor.toFixed(2)}x farther away.`
              : `No ranking penalty.`}
          </Tooltip>
        }
      >
        <span>
          <Badge pill variant={isPenalised ? 'warning' : 'success'}>{`${rate}%`}</Badge>
          <br />
          <small className='text-muted'>{`${acceptance.accepted}/${acceptance.offers}`}</small>
        </span>
      </OverlayTrigger>
    );
  }

  render() {
    const { usersDetails, usersDetails: { getAllUsers }, requestType, getLocationsData } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage, keyword, showFilterModal, draftStatus, draftLocation } = this.state;
    const activeFilterCount = this.getActiveFilterCount();

    let exportType = 'users', pageType = 'users/';
    let paginationLabel = formatMessage(messages.users);

    const isDriverUserType = requestType === 'drivers';

    if (isDriverUserType) {
      exportType = 'drivers';
      pageType = 'drivers/';
      paginationLabel = formatMessage(messages.drivers);
    }

    return (
      <div className={cx(s.widthInner, s.tableSection, 'whiteDropdown', 'widthInnerNoBorder')}>
        <div className={cx(s.exportDisplay, s.tabelExport)}>
          <div className={'textAlignRightRTL'}>
            <div className={s.searchFilterRow}>
              <div className={s.searchInput}>
                <FormControl type='text' placeholder={formatMessage(messages.search)}
                  onChange={(event) => this.handleKeywordSearch(event.target && event.target.value)}
                  className={s.formControlInput} />
              </div>
              <button className={s.filterBtn} onClick={this.openFilterModal}>
                <FaFilter />
                <span>Filter</span>
                {activeFilterCount > 0 && (
                  <span className={s.filterBadge}>{activeFilterCount}</span>
                )}
              </button>
            </div>
          </div>
          <div className={cx(s.exportTextSection, 'textAlignLeftRTL')}>
            {
              usersDetails && getAllUsers && getAllUsers.count > 0 && <a
                href={`/export-admin-data?type=${exportType}&keyword=${keyword}`}
                className={cx('pull-right', s.exportText)}>
                <span className={cx(s.vtrMiddle)}><FormattedMessage {...messages.exportDataIntoCSV} /></span>
                <span className={s.vtrTextBottom}>
                  <img src={ExportImage} className={cx(s.exportImg, 'exportImgRTL')} alt='export icon rtl' />
                </span>
              </a>
            }
          </div>
        </div>
        <div>
          <div className={cx(s.tableCss, 'tableCss', 'tableSticky', 'NewAdminResponsiveTable', 'topScrollbarTable')}>
            <Table className={cx("table", 'topScrollbarTableContent')}>
              <thead>
                <tr>
                  <th scope="col">Joined at</th>
                  <th scope="col">Name</th>
                  <th scope="col">Contact</th>
                  {isDriverUserType && <th scope="col">Status</th>}
                  {isDriverUserType && <th scope="col">Acceptance</th>}
                  <th scope="col" className={s.minWidth}><FormattedMessage {...messages.action} /></th>
                </tr>
              </thead>
              <tbody>
                {
                  usersDetails && getAllUsers && getAllUsers.count > 0 && getAllUsers.results && getAllUsers.results.map((user, index) => {
                    return (
                      <tr key={index}>
                        <td data-label={formatMessage(messages.id)}>{moment(user.createdAt).format('DD-MM-YYYY HH:mm:ss')}</td>
                        <td data-label={formatMessage(messages.firstName)}>
                          <div className='d-flex align-items-center' style={{ gap: '0.5rem' }}>
                            <div className={cx(s.avatarWrapper)}>
                              <img
                                src={user.profile?.picture ? getAvatarUrl(user.profile?.picture) : getUiAvatarUrl(`${user.profile?.firstName} ${user.profile?.lastName}`)}
                                className={cx('rounded-circle')}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                alt='Avatar' />
                              <span className={cx(s.statusBadge, { [s.online]: user.isActive }, { [s.offline]: !user.isActive })}></span>
                            </div>
                            <span>
                              {user.profile &&
                                <span>{capitalizeFirstLetter(user.profile.firstName)} {capitalizeFirstLetter(user.profile.lastName)}</span>}
                              <br />
                              {isDriverUserType && <small className='text-muted'>{user?.location?.locationName}</small>}
                              {isDriverUserType && !user.location && <small className='text-danger'>Not Set</small>}
                            </span>
                          </div>
                        </td>

                        <td data-label={formatMessage(messages.email)}>
                          {`(${user.phoneDialCode}) ${user.phoneNumber}`}
                          <br />
                          {user.email}
                        </td>

                        {isDriverUserType && <td data-label={"Driver Status"}>
                          {this.renderBadgeStatus(user)}
                        </td>}

                        {isDriverUserType && <td data-label={"Acceptance"}>
                          {this.renderAcceptance(user)}
                        </td>}

                        <td data-label={formatMessage(messages.action)}>
                          <div className='d-flex align-items-center' style={{ gap: '0.5rem' }}>
                            <Dropdown>
                              <Dropdown.Toggle variant="light" id="dropdown-basic">
                                Edit
                              </Dropdown.Toggle>

                              <Dropdown.Menu>
                                {isDriverUserType &&
                                  <Dropdown.ItemText>
                                    <label for='userStatus'> Registration Status</label>
                                    <select value={user.userStatus}
                                      onChange={(e) => { this.handleStatus('userStatus', user.id, e.target.value, currentPage) }}
                                      className={cx({ 'bg-warning text-white': user.userStatus === 'pending', 'bg-success text-white': user.userStatus === 'active', 'bg-danger text-white': user.userStatus === 'inactive' })}>
                                      <option value={'pending'}>{formatMessage(messages.pending)}</option>
                                      <option value={'active'}>{formatMessage(messages.approve)}</option>
                                      <option value={'inactive'}>{formatMessage(messages.decline)}</option>
                                    </select>
                                  </Dropdown.ItemText>}
                                <Dropdown.Divider />
                                <Dropdown.Item to={`/siteadmin/${pageType}${user.profile?.profileId}`} as={Link}>
                                  <FaEdit className='mr-2' />
                                  Edit
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => this.handleDelete(user.id, currentPage)} className='text-danger'>
                                  <FaTrash className='mr-2' />
                                  Delete
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                            {isDriverUserType && (
                              <Link to={`/siteadmin/driver-earnings/${user.id}`} className='btn btn-light d-flex align-items-center' style={{ whiteSpace: 'nowrap' }}>
                                <FaChartBar className='mr-2' />
                                Earnings
                              </Link>
                            )}
                          </div>
                        </td>
                      </tr>
                    )
                  })
                }
                {
                  usersDetails && getAllUsers && getAllUsers.count === 0 && <tr>
                    <td colSpan={9} className={s.noRecords}><FormattedMessage {...messages.noResult} /></td>
                  </tr>
                }
              </tbody>
            </Table>
          </div>
        </div>
        {
          usersDetails && getAllUsers && getAllUsers.count > 0 && <div className={cx(s.space5, s.spaceTop5)}>
            <CustomPagination
              total={getAllUsers.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={paginationLabel}
            />
          </div>
        }
        <Modal show={showFilterModal} onHide={this.closeFilterModal} centered>
          <Modal.Header closeButton className={s.modalHeader}>
            <Modal.Title className={s.modalTitle}>Filter {isDriverUserType ? 'Drivers' : 'Users'}</Modal.Title>
          </Modal.Header>
          <Modal.Body className={s.modalBody}>
            <div className={s.modalSection}>
              <div className={s.modalSectionTitle}>Location</div>
              <div className={s.filterSelectWrapper}>
                <select
                  className={s.filterSelect}
                  value={draftLocation}
                  onChange={(e) => this.setState({ draftLocation: e.target.value })}
                >
                  <option value=''>All Locations</option>
                  {getLocationsData && getLocationsData.getLocations && getLocationsData.getLocations.map(loc => (
                    <option key={loc.id} value={loc.id}>{loc.locationName}</option>
                  ))}
                </select>
                <span className={s.filterSelectArrow}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
              </div>
            </div>
            <div className={s.modalSection}>
              <div className={s.modalSectionTitle}>Registration Status</div>
              <div className={s.filterSelectWrapper}>
                <select
                  className={s.filterSelect}
                  value={draftStatus}
                  onChange={(e) => this.setState({ draftStatus: e.target.value })}
                >
                  <option value=''>All Status</option>
                  <option value='active'>Active</option>
                  <option value='pending'>Pending</option>
                  <option value='inactive'>Inactive</option>
                </select>
                <span className={s.filterSelectArrow}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className={s.modalFooter}>
            <button className={s.clearBtn} onClick={this.clearDraftFilters}>Clear All</button>
            <button className={s.applyBtn} onClick={this.applyFilters}>Apply Filters</button>
          </Modal.Footer>
        </Modal>
      </div >
    );
  }
}

const mapDispatch = {
  deleteUser,
  updateShopStatus
};
const mapState = (state) => ({});

export default compose(
  injectIntl,
  withStyles(s),
  connect(mapState, mapDispatch),
  graphql(getLocationsQuery, { name: 'getLocationsData' }),
)(UsersList);